export const HTTP_REQUEST = Symbol('HTTP_REQUEST');
export const HTTP_CLEAR = Symbol('HTTP_CLEAR');

/* Send a HTTP_REQUEST which will be intercepted by the APIMiddleware */
export function sendURLRequest(index, url, options) {
	return {
		type: HTTP_REQUEST,
		index,
		request: {
			url,
			...options,
		}
	};
}

export function clear(index) {
	return {
		type: HTTP_CLEAR,
		index,
	};
}
